/* eslint-disable no-unused-vars */
/* eslint-disable no-lone-blocks */
import React, { useContext, useEffect, useState } from 'react';
import {
  ChevronRightRounded,
  ExpandLessRounded, ExpandMoreRounded,
} from '@mui/icons-material';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Switch,
  TextField,
} from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'react-medium-image-zoom/dist/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Images from '../../../../Configs/images';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import {
  getAdminRequestDetails, assignCourier, assignItemsToBox, updateCourierRequest, setRequestAsDone,
} from '../../../../Redux/Models/request';
import { getCourier } from '../../../../Redux/Models/courier';
import { getDigitalBox } from '../../../../Redux/Models/box';
import { BoxItemData, BoxItemForm } from '../../Courier/RequestDetails/RequestDetails';
import { getCategories, getConditions } from '../../../../Redux/Models/master';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import { alphabets } from '../../../../Configs/alphabets';

export default function RequestIn({
  classes, selectedRequest, courierSelected, isLoading, error, message, validatedRequest,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { requestId } = useParams();
  const [activeStep, setActiveStep] = useState(1);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [unproceed, setUnproceed] = useState(false);
  const [choosenCourier, setChoosenCourier] = useState({ front_name: '', id: '' });
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  const initItem = {
    item1: {},
  };
  const [boxes, setBoxes] = useState({
    'box-1': initItem,
  });
  const [totalItems, setTotalItems] = useState(0);

  const { couriers } = useSelector((state) => state.courier);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChangeItem = (boxName, itemName, newVal) => {
    setBoxes({
      ...boxes,
      [boxName]: {
        ...boxes[boxName],
        [itemName]: newVal,
      },
    });
  };

  const closeModalConfirm = () => {
    setOpenConfirm(false);
  };

  const changeStep = (newStep) => () => {
    setActiveStep(newStep);
    closeModalConfirm();
  };

  useEffect(() => {
    const courierOnIt = ['Waiting for Courier Acceptance', 'Courier On The Way', 'Courier Arrived at Pickup Place', 'Pickup Already Confirm by Customer'];
    if (courierOnIt.indexOf(selectedRequest.status) > -1) {
      changeStep(2)();
    } else if (selectedRequest.status === 'Arrived at Warehouse') {
      changeStep(3)();
    } else if (selectedRequest.status === 'Stored at Warehouse') {
      changeStep(4)();
    } else if (selectedRequest.status === 'Done') {
      changeStep(4)();
      openConfirmation({
        title: 'The request process has done',
        desc: 'You can back to home',
        confirmText: 'Ok, go back',
        cancelText: 'Stay here',
        handleAgree: () => {
          navigate(ROUTES.home());
          closeConfirmation();
        },
        handleClose: () => {
          closeConfirmation();
        },
      });
    }

    // {name, id}

    if (selectedRequest.items) {
      // const newBoxes = {};
      // const total = [];
      // Object.keys(selectedRequest.items).forEach((boxKey) => {
      //   let index = 1;
      //   const items = {};
      //   selectedRequest.items[boxKey].forEach((item) => {
      //     items[`item${index}`] = item;
      //     index += 1;
      //     total.push(item.id);
      //   });

      //   newBoxes[boxKey] = items;
      // });

      // setBoxes(newBoxes);
      setTotalItems(selectedRequest.items?.length);
    }

    if (selectedRequest.box) {
      const newBoxes = {
        'box-1': {},
      };
      setBoxes(newBoxes);
      setTotalItems(selectedRequest.box?.amount);
    }
  }, [selectedRequest]);

  const getInitialData = () => {
    dispatch(getAdminRequestDetails(requestId));
    dispatch(getCourier());
    dispatch(getCategories());
    dispatch(getConditions());
  };

  useEffect(() => {
    dispatch(getDigitalBox(selectedRequest.box?.id ? 'Box' : 'Item'));
  }, [selectedRequest.box]);

  useEffect(() => {
    if (!requestId) {
      navigate(-1);
    } else {
      getInitialData();
    }
  }, [requestId]);

  const getImage = (name, step) => {
    if (step === activeStep) return Images[`${name}Active2`];
    if (step > activeStep) return Images[name];
    return Images.Check2;
  };

  const handleAssignCourier = () => {
    dispatch(assignCourier(requestId, { courier: choosenCourier.id }));
  };

  const [hideReqInfo, setHideRI] = useState(false);
  const [hideOwnerInfo, setHideOI] = useState(false);
  const [hideItemInfo, setHideII] = useState(false);
  const [hideTrackHistory, setHideTH] = useState(false);

  useEffect(() => {
    if (courierSelected) {
      dispatch(getAdminRequestDetails(requestId));
      setOpenConfirm(false);
    }
  }, [courierSelected]);

  useEffect(() => {
    if (activeStep >= 2) {
      setHideRI(true);
      setHideOI(true);
      setHideII(true);
    } else {
      setHideRI(false);
      setHideOI(false);
      setHideII(false);
    }
  }, [activeStep]);

  const wantToContinue = () => {
    let valid = false;
    const showAlert = (mssg) => {
      setSnackbar({
        open: true,
        message: mssg,
        severity: 'error',
      });
    };

    switch (activeStep) {
      case 1: valid = true;
        break;
      case 2: {
        if (selectedRequest.status === 'Pickup Already Confirm by Customer') {
          changeStep(3)();
        } else if (!selectedRequest.driver) {
          valid = choosenCourier.id;
          if (!valid) {
            showAlert('Please choose courier!');
          }
        } else {
          showAlert('Wait for courier to finish his/her job');
        }
      }
        break;
      case 3:
      case 4:
        valid = true;
        break;
      default: valid = false;
    }

    if (valid) {
      setOpenConfirm(true);
    }
  };

  const [digitalBox, setDigitalBox] = useState({});

  const handleDigitalBox = (newVal) => {
    // if (newVal.row && newVal.column) {
    //   const filteredDigiBox = digitalBox.filter(
    //     (db) => db.row === newVal.row && db.column === newVal.column,
    //   );
    //   const existingDigiBox = Boolean(filteredDigiBox.length);
    //   if (existingDigiBox) {
    //     // update box
    //     const newDigiBoxes = digitalBox.map((db) => {
    //       if (db.row === newVal.row && db.column === newVal.column) {
    //         return newVal;
    //       }
    //       return db;
    //     });
    //     setDigitalBox(newDigiBoxes);
    //   } else {
    //     // add box
    //     const newDigiBoxes = [...digitalBox];
    //     newDigiBoxes.push(newVal);
    //     setDigitalBox(newDigiBoxes);
    //   }
    // }
    setDigitalBox(newVal);
  };

  const handleAssignItemsToBox = () => {
    if (!digitalBox.row || !digitalBox.rack) {
      setSnackbar({
        open: true,
        message: 'Complete warehouse validation! Please choose storage site!',
        severity: 'error',
      });
      return;
    }
    const body = {
      owner_id: selectedRequest.user?.id,
      digital_box: [
        {
          // ...digitalBox[0],
          ...digitalBox,
          box: selectedRequest.box?.id || '',
        },
      ],
    };

    dispatch(assignItemsToBox(requestId, body));
  };

  const updateStatus = (status) => {
    // const body = {
    //   status,
    // };
    dispatch(setRequestAsDone(requestId));
  };

  useEffect(() => {
    if (validatedRequest === requestId) {
      setSnackbar({
        open: true,
        message: 'Successfully assign request to box',
        severity: 'success',
      });
      getInitialData();
    }

    if (error) {
      setSnackbar({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [validatedRequest, error]);

  const renderRequestInfo = () => (
    <div className="info-card mt-3">
      <div className="flex space-between link" onClick={() => setHideRI(!hideReqInfo)}>
        <h3>Request Info</h3>
        {hideReqInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hideReqInfo}>
        <Divider sx={{ my: 2 }} />
        <div className="flex space-between align-items-center">
          <div className="flex align-items-center gap-4">
            <img src={Images.RequestInRounded2} alt="req-in" />
            <div className="s-14 weight-500">Request in</div>
          </div>
          <div className="status">{selectedRequest.status}</div>
        </div>

        <div className="flex space-between align-items-center space-between mt-3 gap-16">
          <div className="flex-1">
            <div className="mute s-12">Request ID</div>
            <div className="weight-700 mt-1">{selectedRequest.id}</div>
          </div>
          <div className="flex-1">
            <div className="mute s-12">Request date</div>
            <div className="weight-700 mt-1">{moment(new Date(selectedRequest.pickup_date)).format('HH.mm - DD/MM/YYYY')}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderOwnerInfo = () => (
    <div className="info-card mt-3">
      <div className="flex space-between link" onClick={() => setHideOI(!hideOwnerInfo)}>
        <h3>Owner Info</h3>
        {hideOwnerInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hideOwnerInfo}>
        <Divider sx={{ my: 2 }} />
        <div className="flex space-between align-items-center">
          <div>
            <div className="mute s-12">User ID</div>
            <div className="weight-700 mt-1">{selectedRequest.user?.id}</div>
          </div>
          <div className="plan flex align-items-center gap-4">
            <img alt="subs" src={selectedRequest.user?.subscription === 'Normal Plan' ? Images.NormalStar : Images.PremiumStar} height="24" />
            <div className="s-14 weight-500">{selectedRequest.user?.subscription}</div>
          </div>
        </div>
        <div className="mt-3">
          <div className="mute s-12">User name</div>
          <div className="weight-700 mt-1">{`${selectedRequest.user?.front_name} ${selectedRequest.user?.back_name}`}</div>
        </div>
        <div className="flex space-between align-items-center mt-3">
          <div>
            <div className="mute s-12">Phone number</div>
            <div className="weight-700 mt-1">
              +
              {selectedRequest.pickup_address?.phone_number}
            </div>
          </div>
          <img src={Images.PhoneOrange} alt="phone" />
        </div>
        <div className="flex space-between align-items-center mt-3">
          <div>
            <div className="mute s-12">Pick up address</div>
            <div className="weight-700 mt-1">{selectedRequest.pickup_address?.address}</div>
          </div>
          <img src={Images.LocationOrange} alt="Pick up address" />
        </div>
      </div>
    </div>
  );

  const renderItemInfo = () => (
    <div className="info-card mt-3">
      <div className="flex space-between link" onClick={() => setHideII(!hideItemInfo)}>
        <h3>Item Info</h3>
        {hideItemInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hideItemInfo}>
        <Divider sx={{ my: 2 }} />
        <div className="flex gap-20 align-items-start">
          <img alt="req-in" src={Images.RequestInActive2} />
          {selectedRequest.box
            ? (
              <Box display="flex" gap={1.5} mt={1.5} alignItems="flex-start">
                <img width="80px" height="80px" className="rounded cover" src={selectedRequest.box?.photo || 'https://images.pexels.com/photos/2912108/pexels-photo-2912108.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'} alt="box" />
                <Box flex={1}>
                  <div className="weight-600">
                    {selectedRequest.box?.name || `Box ${selectedRequest.box?.digital_box_id}`}
                  </div>
                  <Box>
                    {selectedRequest.box?.amount}
                    {' '}
                    Items
                  </Box>
                </Box>
              </Box>
            )
            : (
              <div className="flex-1">
                <div className="flex space-between">
                  <div className="flex-1">
                    <div className="mute s-12">Category</div>
                    <div className="weight-700 mt-1">{selectedRequest.category?.name}</div>
                  </div>
                  {/* <div className="flex-1">
                <div className="mute s-12">Total items</div>
                <div className="weight-700 mt-1">
                  {selectedRequest.items}
                  {' '}
                  Items
                </div>
              </div> */}
                  <div className="flex-1">
                    <div className="mute s-12">Item condition</div>
                    <div className="weight-700 mt-1">{selectedRequest.condition?.name}</div>
                  </div>
                </div>
                <div className="mt-3">
                  <div className="mute s-12">Item notes</div>
                  <div className="weight-700 mt-1">{selectedRequest.item_notes}</div>
                </div>
                <div className="mt-3">
                  <div className="mute s-12">Pickup notes</div>
                  <div className="weight-700 mt-1">{selectedRequest.pickup_notes}</div>
                </div>
              </div>
            )}
        </div>

        <Box>
          {!!selectedRequest.items && selectedRequest.items?.map((item, i) => (
            <Box mt={0.5} border="1px solid #F5F6F8" borderRadius={1} py={0.5} px={1} key={item.id}>
              <div className="s-10 weight-700">
                Item
                {' '}
                {i + 1}
              </div>
              <Box display="flex" alignItems="flex-start" mt={0.5}>
                <Box flex={2}>
                  <div className="mute s-10">Wine name</div>
                  <div className="s-12 weight-600">{item.name}</div>
                </Box>
                <Box flex={1}>
                  <div className="mute s-10">Wine volume</div>
                  <div className="s-12 weight-600">
                    {item.volume}
                  </div>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </div>

    </div>
  );

  const renderCourierSection = () => {
    if (selectedRequest.driver) {
      return (
        <div className="info-card mt-3">
          <h3>Track courier</h3>
          <Divider sx={{ my: 2 }} />
          <div className="flex align-items-start gap-16">
            <img src={selectedRequest.driver?.profile_picture} alt="driver" height="48" width="48" className="circle cover" />
            <div className="flex-1">
              <div className="flex space-between">
                <div>
                  <div className="s-12 mute">Courier name</div>
                  <div className="s-16 weight-700 mt-2">{selectedRequest.driver?.front_name}</div>
                </div>
                <div>
                  <div className="s-12 mute">Courier ID</div>
                  <div className="s-16 weight-700 mt-2">
                    {selectedRequest.driver?.id}
                  </div>
                </div>
                <div>
                  <div className="s-12 mute">Status</div>
                  <div className="s-12 weight-500 mt-2 pil">{selectedRequest.status}</div>
                </div>
              </div>
              <div className="mt-3">
                <div className="s-12 mute">Phone number</div>
                <div className="s-16 weight-700 mt-2">{selectedRequest.driver?.phone_number}</div>
              </div>
            </div>
          </div>
          <Box sx={{
            borderRadius: 2,
            border: '1px solid #DADADA',
            p: 2,
            mt: 2,
          }}
          >
            <div className="flex space-between link" onClick={() => setHideTH(!hideTrackHistory)}>
              <h3>Track history</h3>
              {hideTrackHistory
                ? <ExpandMoreRounded fontSize="medium" />
                : <ExpandLessRounded fontSize="medium" />}
            </div>
            <div hidden={hideTrackHistory}>
              <Divider sx={{ my: 2 }} />
              <div className="stepper">
                {selectedRequest.tracking_history.map((history, idx) => (
                  <div className="flex gap-16 mt-2" key={history.timestamp}>
                    <img src={idx === 0 ? Images.LinePointActive : Images.LinePoint} alt="line point" />
                    <div className="flex space-between flex-1">
                      <div>
                        <div className="weight-700 mt-1 s-16">{history.title}</div>
                        <div className="s-14 mute mt-1">{history.description || '-'}</div>
                      </div>
                      <div className="s-14 mute">
                        {moment(new Date(history.timestamp)).format('HH.mm')}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Box>
        </div>
      );
    }
    return (
      <div className="info-card mt-3">
        <h3>Assign courier</h3>
        <Divider sx={{ my: 2 }} />
        <div>
          <label>Choose courier</label>
          <Autocomplete
            autoComplete
            options={couriers}
            value={choosenCourier}
            onChange={(e, newVal) => setChoosenCourier(newVal)}
            getOptionLabel={(opt) => opt.front_name || ''}
            renderOption={(optProp, opt) => (
              <Box sx={{ px: 2, py: 1 }} {...optProp} className="flex gap-8 align-items-center link" style={{ gap: '8px !important' }}>
                <img src={opt.profile_picture} alt="profile_pict" width="40" height="40" className="courier-opt" style={{ borderRadius: 50 }} />
                <div>
                  <div className="weight-700">{opt.front_name}</div>
                  <div className="s-14 mute">{opt.id}</div>
                </div>
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Choose courier"
                InputProps={{
                  ...params.InputProps,
                }}
                size="small"
              />
            )}
          />
          <div className="s-12 mute mt-3">
            <strong>{couriers.length}</strong>
            {' '}
            Available couriers
          </div>
        </div>
      </div>
    );
  };

  const renderBoxForm = (key, index) => {
    const selectedBox = boxes[key];
    return (
      <div className="info-card mt-3" key={key}>
        <div>
          <div>
            <h3>
              Item validation Box
              {' '}
              {index + 1}
            </h3>
            <div className="mute s14 mt-1">1 box only carried 6 items</div>
          </div>

          <Divider sx={{ mt: 2 }} />
          {Object.keys(selectedBox).map((item, i) => (
            <BoxItemForm
              key={i}
              index={i}
              onFieldChange={(newData) => handleChangeItem(key, item, newData)}
              setSnackbar={setSnackbar}
            />
          ))}
        </div>
      </div>
    );
  };

  const renderBoxItems = () => (
    <div className="info-card mt-3">
      <div>
        <div>
          <h3>
            Pick up validation from Courier
          </h3>
        </div>
        <Divider sx={{ my: 2 }} />
        <div className="flex">
          <div className="flex-1">
            <div className="s-12 mute">Total box</div>
            <div className="weight-700 mt-2">
              {selectedRequest.box?.volume}
              {' '}
              box
            </div>
          </div>
          <div className="flex-1">
            <div className="s-12 mute">Total items</div>
            <div className="weight-700 mt-2">
              {totalItems}
              {' '}
              items
            </div>
          </div>
        </div>
        <BoxToValidate
          selectedBox={selectedRequest.items}
          classes={classes}
          updateDigitalBox={handleDigitalBox}
        />
      </div>
    </div>
  );

  const renderSubmitText = () => {
    switch (activeStep) {
      case 1: return 'Proceed';
      case 2: {
        // if (selectedRequest.driver) {
        if (selectedRequest.status === 'Pickup Already Confirm by Customer') {
          return 'Accepting item';
        } if (!selectedRequest.driver) {
          return 'Assign courier';
        }
        return null;
      }
      case 3: return 'Accepting item';
      case 4: return 'Finish';
      default: return 'Proceed';
    }
  };

  return (
    <Elements.AdminPageBase
      title="Dashboard"
      breadcrumbs={(
        <div className="mt-3">
          <Link to="/" className="link weight-700 black">Dashboard</Link>
          {' '}
          / New request in
        </div>
    )}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <div className="mt-4">
          <div className="flex align-items-center flex-center">
            <div className="center">
              <img src={getImage('RequestIn', 1)} alt="Request in order data" />
              <div className={`mt-1 s-14 ${activeStep === 1 && 'weight-700'}`}>Request in order data</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('Courier', 2)} alt="Courier assign" />
              <div className={`mt-1 s-14 ${activeStep === 2 && 'weight-700'}`}>Courier assign</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('WarehouseValidate', 3)} alt="Warehouse validate" />
              <div className={`mt-1 s-14 ${activeStep === 3 && 'weight-700'}`}>Warehouse validate</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('Confirmation', 4)} alt="WConfirmation" />
              <div className={`mt-1 s-14 ${activeStep === 4 && 'weight-700'}`}>Confirmation</div>
            </div>
          </div>
        </div>

        <div>
          <Grid container justifyContent="center" className="mt-3">
            <Grid item lg={8} sm={10} xs={12}>

              {activeStep === 2 && renderCourierSection()}
              {activeStep === 3 && renderBoxItems()}

              {renderRequestInfo()}

              {renderOwnerInfo()}

              {renderItemInfo()}

              <div className="flex justify-end gap-16 mt-4">
                {selectedRequest.status !== 'Done'
                && <Button sx={{ px: 4 }} variant="outlined" className="action btn-outlined" onClick={() => setUnproceed(true)} disabled={selectedRequest.status === 'Done'}>Unproceed</Button>}
                {Boolean(activeStep === 4)
                && <Button sx={{ px: 4 }} variant="outlined" className="action btn-outlined" onClick={() => setActiveStep(3)}>Back</Button>}
                {!!renderSubmitText() && selectedRequest.status !== 'Done'
                && <Button sx={{ px: 4 }} variant="contained" className="action btn-contained" onClick={wantToContinue}>{renderSubmitText()}</Button>}
              </div>
            </Grid>
          </Grid>

        </div>

      </div>

      <Elements.ConfirmationModal
        open={unproceed}
        desc={(
          <div>
            Are you sure want to unproceed this
            <br />
            Request? this process cannot be undone
          </div>
        )}
        handleClose={() => setUnproceed(false)}
        handleAgree={() => navigate(ROUTES.home())}
      />
      <Elements.ConfirmationModal
        open={activeStep === 1 && openConfirm}
        desc={(
          <div>
            Are you sure want to proceed
            {' '}
            <br />
            this request in pickup order request?
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={changeStep(2)}
      />
      <Elements.ConfirmationModal
        open={activeStep === 2 && openConfirm}
        desc={(
          <div>
            Assign pick up order request
            <br />
            to this Courier?
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={handleAssignCourier}
        isLoading={isLoading}
      />
      <Elements.ConfirmationModal
        open={activeStep === 3 && openConfirm}
        desc={(
          <div>
            Before confirming the item validation process,
            make sure to recheck again the item and information data!
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={handleAssignItemsToBox}
        isLoading={isLoading}
      />
      <Elements.ConfirmationModal
        open={activeStep === 4 && openConfirm}
        desc={(
          <div>
            Before you finish the request in order
            <br />
            make sure all of data are rights and filled up
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={() => updateStatus('Done')}
        isLoading={isLoading}
      />
    </Elements.AdminPageBase>
  );
}

export function BoxToValidate({
  selectedBox = [], index = 0, classes, updateDigitalBox,
}) {
  const { box } = useSelector((state) => state);

  const [hideBox, setHideBox] = useState(false);
  const [chooseBox, setChooseBox] = useState(false);
  const [confirmRack, setConfirmRack] = useState(false);
  const [selectedRack, setSelectedRack] = useState({});
  const [items, setItems] = useState([]);

  useEffect(() => {
    const itemIds = [];
    selectedBox.forEach((item) => {
      itemIds.push(item.id);
    });
    setItems(itemIds);
  }, [selectedBox]);

  const [fields, setField] = useState({
    warehouse_notes: '',
    box_code: '',
    is_verified_item_status: true,
  });

  useEffect(() => {
    updateDigitalBox(fields);
  }, [fields]);

  const handleChangeField = (e) => {
    setField({
      ...fields,
      [e.target.name]: e.target.value,
    });
  };

  const checkBeforeOpenConfirmation = () => {
    if (selectedRack.id) {
      setConfirmRack(true);
    }
  };

  const handleSelectRack = (col) => {
    if (col.is_available) {
      setSelectedRack(col);
    }
  };

  const chooseRack = () => {
    if (selectedRack.id) {
      const { column, rack, row } = selectedRack;
      setField({
        ...fields,
        column,
        rack,
        row,
        items,
      });
      setConfirmRack(false);
      setChooseBox(false);
    }
  };

  return (
    <Box sx={{
      borderRadius: 2,
      border: '1px solid #DADADA',
      p: 2,
      mt: 2,
    }}
    >
      <div className="flex space-between link" onClick={() => setHideBox(!hideBox)}>
        <div className="weight-700">
          {' '}
          Box
          {' '}
          {index + 1}

        </div>
        {hideBox
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>

      <div hidden={hideBox}>
        {selectedBox.map((item, i) => (
          <BoxItemData
            key={i}
            index={i}
            data={item}
          />
        ))}
      </div>
      <div className="mt-3">
        <h4>Warehouse validate</h4>
        <Divider sx={{ my: 2 }} />
        {/* <div className="flex space-between">
          <div>Verified item status</div>
          <div>
            <Switch checked={fields.is_verified_item_status} onChange={toggleVerified} />
          </div>
        </div> */}
        <div className="mt-1">
          <div>Warehouse note</div>
          <TextField value={fields.warehouse_notes} name="warehouse_notes" onChange={handleChangeField} sx={{ mt: 1 }} fullWidth placeholder="Type here" />
        </div>
        <div className="mt-3">
          <div>Storage site</div>
          <TextField
            sx={{ mt: 1 }}
            fullWidth
            placeholder="Choose storage"
            disabled
            value={selectedRack.id ? selectedRack.column + selectedRack.row : ''}
            InputProps={{
              endAdornment: (
                <IconButton sx={{ p: 0 }} onClick={() => setChooseBox(true)}>
                  <ChevronRightRounded fontSize="large" />
                </IconButton>
              ),
            }}
          />
        </div>
        <div className="mt-3">
          <div>Box code</div>
          <TextField value={fields.box_code} name="box_code" onChange={handleChangeField} sx={{ mt: 1 }} fullWidth placeholder="Type here" />
        </div>
      </div>

      <Elements.ModalBase
        maxWidth="lg"
        open={chooseBox}
        confirmText="Choose aisle"
        handleClose={() => setChooseBox(false)}
        handleAgree={checkBeforeOpenConfirmation}
      >
        <Container maxWidth="md">
          <div className={classes.boxes}>
            <div className="flex space-between">
              <div>
                <div className="flex align-items-center">
                  <div className="storage available" />
                  <div>
                    <div className="weight-700">800/1000</div>
                    <div className="s-14">available storages</div>
                  </div>
                </div>
              </div>

              <div className="flex align-self-center gap-16">
                <div className="flex align-items-center">
                  <div className="storage not_available" />
                  <div>
                    <div className="weight-700">Used storage</div>
                  </div>
                </div>
                <div className="flex align-items-center">
                  <div className="storage empty" />
                  <div>
                    <div className="weight-700">Empty storage</div>
                  </div>
                </div>
              </div>
            </div>
            <Grid container spacing={1} sx={{ mt: 2 }} justifyContent="center">
              {box.data?.data?.map((e, idx) => {
                const columnLength = e.row[0].column?.length;
                return (
                  <Grid item lg={6} key={idx} sx={{ mb: 2 }}>
                    <div className="center">
                      <div className="s-18 weight-700">
                        Aisle
                        {' '}
                        {e.name}
                      </div>
                    </div>
                    <table className="mt-3">
                      <thead>
                        <tr>
                          <td aria-label="empty-td" />
                          {new Array(columnLength).fill(null).map((col, id) => (
                            <td className="s-14 center weight-700 mute" key={id}>{id + 1}</td>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {e.row.map((ev, i) => (
                          <tr key={i}>
                            <td className="s-14">{alphabets[i]}</td>
                            {ev.column.map((col) => (
                              // rack
                              <td key={col.id} aria-label={col.id}>
                                <div
                                  className={`storage pointer ${col.status} ${col.id === selectedRack.id ? 'selected' : ''}`}
                                  onClick={() => handleSelectRack(col)}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </Container>
      </Elements.ModalBase>

      <Elements.ConfirmationModal
        open={confirmRack}
        handleClose={() => setConfirmRack(false)}
        handleAgree={chooseRack}
        desc="Are you sure choose this aisle?"
      />
    </Box>
  );
}
